// extracted by mini-css-extract-plugin
module.exports = {"AnnualPlans":"AnnualPlans_AnnualPlans__1g1ln","annualPlans":"AnnualPlans_AnnualPlans__1g1ln"};